"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var defaults = {
  font_sizes: '8/66%;10/83%;12/100%;14/117%',
  font_names: "Arial/Arial, Helvetica, sans-serif;Comic Sans MS/Comic Sans MS, cursive;Courier New/Courier New, Courier, monospace;Georgia/Georgia, serif;Lucida Sans Unicode/Lucida Sans Unicode, Lucida Grande, sans-serif;Tahoma/Tahoma, Geneva, sans-serif;Times New Roman/Times New Roman, Times, serif;Trebuchet MS/Trebuchet MS, Helvetica, sans-serif;Verdana/Verdana, Geneva, sans-serif",
  default_font_family: "Arial, Helvetica, sans-serif",
  colors: '000,800000,8B4513,2F4F4F,008080,000080,' + '4B0082,696969,B22222,A52A2A,DAA520,006400,' + '40E0D0,0000CD,800080,808080,FF8C00,FFD700,' + '008000,0FF,00F,EE82EE,A9A9A9,FFA07A,' + 'FFA500,FFFF00,00FF00,AFEEEE,ADD8E6,DDA0DD',
  audio_url_prefix: process.env.PUBLIC_PATH + 'audio/',
  WINDOW_AUTOCLOSE_INTERVAL: 30 * 1000,
  // 30 seconds
  ANONYMOUS_SESSION_LIMIT: 10 * 60,
  // 10 minutes
  ROOM_HISTORY_LIMIT: 250,
  SENTRY_DSN: 'https://d339c13964f94a0988cd0c577bd7d232@sentry.bobtv.fr/2',
  FIREBASE_CREDENTIALS: {
    apiKey: "AIzaSyBmoA2EawMFy5Wmzg2UIPBvggtGdKC_Bbw",
    authDomain: "bobtv-push.firebaseapp.com",
    databaseURL: "https://bobtv-push.firebaseio.com",
    projectId: "bobtv-push",
    storageBucket: "bobtv-push.appspot.com",
    messagingSenderId: "952339726096",
    appId: "1:952339726096:web:d238e2f9ff95f527cbaf95",
    measurementId: "G-8Z18BJDZ05"
  }
};
var overrides = {};
try {
  overrides = require('./app.config.override');
} catch (e) {}
var _default = Object.assign({}, defaults, overrides);
exports["default"] = _default;